import { render, staticRenderFns } from "./MicroDepositVerificationModal.vue?vue&type=template&id=2b0e3385&scoped=true"
import script from "./MicroDepositVerificationModal.vue?vue&type=script&lang=js"
export * from "./MicroDepositVerificationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0e3385",
  null
  
)

export default component.exports